import React, { Component } from "react";
import {
  Box,
  Grid, Tab, Tabs,
  Typography
} from "@mui/material";
import {
  withStyles
} from "@mui/styles";
import {
  HeadElement,
  SearchInput,
  ItemSettingLevel,
  ShopFloorEfficiency,
  FilterWorkForAnalysis
} from "./components";
import {
  VisibleContent
} from "../../../components";
import agent from "../../../agent/agent";
import moment from "moment";
import "moment/locale/ru";

const initFilter = {
  year: "",
  month: "",
  search: "",
  type: "mechanic",
  page: 1,
  limit: 20,
};
const initWorkAnalysisFilter = {
  date_from: moment().startOf("month").format("YYYY-MM-DD"),
  date_to: moment().endOf("month").format("YYYY-MM-DD"),
  work_name: "",
  analysisType: "less_than_08",
  page: 1,
  per_page: 20,
  group_by_brand: false,
  group_by_model: false,
  group_by_year: false,
  group_by_engine: false,
};

class AdministratorStatistics extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      totals: {},
      filter: {...initFilter},
      totalPages: 1,
      isLoading: true,
      workAnalysisFilter: {...initWorkAnalysisFilter},
      workAnalysisData: { period: null, analysis: { less_than_08: [], more_than_13: [] } },
      workAnalysisLoading: false,
      workAnalysisTotalPages: 1,
    };
  }

  componentDidMount = async () => {
    await this.getItems();
    await this.getWorkAnalysos();
  }

  formatPeriod = (periodString) => {
    if (!periodString) return "";
    const mDate = moment(periodString, "YYYY-MM");
    const formatted = mDate.locale("ru").format("MMMM YYYY");
    return formatted.charAt(0).toUpperCase() + formatted.slice(1) + " год";
  }
  getItems = async () => {
    await this.setState({isLoading: true});
    const filter = this.getFilter();
    const response = await agent.get(`/mechanic-statistics/summary?${ filter }`)
      .then((res) => res?.data).catch(() => null);
    this.setState({
      isLoading: false,
      totals: response?.totals,
      items: response?.items || [],
      totalPages: response?.pagination?.last_page || 1,
      period: this.formatPeriod(response?.period),
    });
  }

  getFilter = () => {
    const { filter } = this.state;
    return Object.entries(filter)
      .filter(([, value]) => value !== "" && value != null)
      .map(([key, value]) => `${key}=${value}`)
      .join("&");
  };
  resetFilter = async () => {
    await this.setState({filter: {...initFilter}, isLoading: true});
    await this.getItems();
  }
  changeFilter = async (filter, isFastStart) => {
    await this.setState({filter});
    if (!isFastStart) {
      return
    }
    await this.getItems();
  }

  getWorkAnalysos = async () => {
    await this.setState({ workAnalysisLoading: true });
    const q = this.getWorkAnalysisFilter();
    const response = await agent
      .get(`/mechanic-statistics/work-analysis?${q}`)
      .then((res) => res?.data)
      .catch(() => null);
    const totalPages = response?.last_page ?? 1;
    const currentType = this.state.workAnalysisFilter.analysisType;
    const hasGroups = Array.isArray(response?.groups);
    const dataList = hasGroups ? response.groups : (response?.data ?? []);
    this.setState((prev) => ({
      workAnalysisLoading: false,
      workAnalysisData: {
        period: response?.period ?? prev.workAnalysisData.period,
        groups: hasGroups ? dataList : null,
        analysis: hasGroups
          ? { less_than_08: [], more_than_13: [] }
          : {
              less_than_08: currentType === "less_than_08" ? dataList : prev.workAnalysisData.analysis.less_than_08,
              more_than_13: currentType === "more_than_13" ? dataList : prev.workAnalysisData.analysis.more_than_13,
            },
      },
      workAnalysisTotalPages: totalPages,
    }));
  };
  getWorkAnalysisFilter = () => {
    const f = this.state.workAnalysisFilter;
    const parts = [];
    if (f.date_from) parts.push(`date_from=${encodeURIComponent(f.date_from)}`);
    if (f.date_to) parts.push(`date_to=${encodeURIComponent(f.date_to)}`);
    if (f.work_name) parts.push(`work_name=${encodeURIComponent(f.work_name)}`);
    parts.push(`type=${encodeURIComponent(f.analysisType || "less_than_08")}`);
    if (f.page != null) parts.push(`page=${Number(f.page)}`);
    if (f.per_page != null) parts.push(`per_page=${Number(f.per_page)}`);
    if (f.group_by_brand) parts.push("group_by_brand=true");
    if (f.group_by_model) parts.push("group_by_model=true");
    if (f.group_by_year) parts.push("group_by_year=true");
    if (f.group_by_engine) parts.push("group_by_engine=true");
    return parts.join("&");
  };
  changeWorkAnalysisFilter = (workAnalysisFilter) => {
    this.setState({ workAnalysisFilter });
  };
  applyWorkAnalysisFilter = async () => {
    await this.setState((s) => ({
      workAnalysisFilter: { ...s.workAnalysisFilter, page: 1 },
    }));
    await this.getWorkAnalysos();
  };
  toggleWorkAnalysisGroup = async (groupKey) => {
    await this.setState((s) => {
      const isActive = s.workAnalysisFilter[groupKey];
      return {
        workAnalysisFilter: {
          ...s.workAnalysisFilter,
          group_by_brand: false,
          group_by_model: false,
          group_by_year: false,
          group_by_engine: false,
          [groupKey]: !isActive,
          page: 1,
        },
      };
    });
    await this.getWorkAnalysos();
  };
  setWorkAnalysisTab = async (analysisType) => {
    await this.setState((s) => ({
      workAnalysisFilter: { ...s.workAnalysisFilter, analysisType, page: 1 },
    }));
    await this.getWorkAnalysos();
  };
  changeWorkAnalysisPage = async (event, page) => {
    await this.setState((s) => ({
      workAnalysisFilter: { ...s.workAnalysisFilter, page },
    }));
    await this.getWorkAnalysos();
  };

  render() {
    const {
      items,
      filter,
      period,
      totals,
      isLoading,
      totalPages,
      workAnalysisFilter,
      workAnalysisData,
      workAnalysisTotalPages,
      workAnalysisLoading,
    } = this.state;
    const { classes, userRole } = this.props;
    const isAdmin = userRole === "admin";

    return (
      <>
        <HeadElement title={isAdmin ? "Администратор" : "Консультант"} />
        <VisibleContent visible={isAdmin}>
          <Box mt={2} />
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <ItemSettingLevel title="ДЛЯ Механика" type="mechanic" />
            </Grid>
            <Grid item xs={6}>
              <ItemSettingLevel title="ДЛЯ Диагноста" type="diagnost" />
            </Grid>
          </Grid>
        </VisibleContent>
        <Box mt={2} />
        <Box sx={{ background: "#fff", borderRadius: "20px", padding: "20px 30px", boxSizing: "border-box" }}>
          <Typography className={classes.title}>Эффективность цеха</Typography>
          <Tabs value={filter.type} className={classes.tabs} onChange={(e, type) => this.changeFilter({ ...filter, page: 1, type }, true)}>
            <Tab label="Механики" value="mechanic" />
            <Tab label="Диагносты" value="diagnost" />
          </Tabs>
          <Box mt={2} />
          <SearchInput filter={filter} onChange={this.changeFilter} onReset={this.resetFilter} />
          <Box mt={2} />
          <ShopFloorEfficiency
            items={items}
            filter={filter}
            period={period}
            totals={totals}
            isLoading={isLoading}
            totalPages={totalPages}
            onChangFilter={this.changeFilter}
          />
        </Box>
        <Box mt={2} />
        <Box sx={{ background: "#fff", borderRadius: "20px", padding: "20px 30px", boxSizing: "border-box" }}>
          <Typography className={classes.title}>Таблица работ для анализа</Typography>
          <FilterWorkForAnalysis
            filter={workAnalysisFilter}
            data={workAnalysisData}
            totalPages={workAnalysisTotalPages}
            onChangeFilter={this.changeWorkAnalysisFilter}
            onApply={this.applyWorkAnalysisFilter}
            onTabChange={this.setWorkAnalysisTab}
            onGroupToggle={this.toggleWorkAnalysisGroup}
            onPageChange={this.changeWorkAnalysisPage}
            isLoading={workAnalysisLoading}
          />
        </Box>
      </>
    );
  }
}

const styles = {
  title: {
    marginBottom: 10,
    fontSize: 24,
    fontWeight: 700,
    color: "#434146",
    lineHeight: "29px",
    letterSpacing: "0.03em",
  },
  tabs: {
    borderBottom: "1px solid #F3F3F3",
    minHeight: 40,
    marginBottom: 20,

    "& .MuiTabs-flexContainer": {
      gap: "20px"
    },
    "& .MuiButtonBase-root": {
      padding: "0px",
      minWidth: 0,
      height: 40,
      minHeight: 40,
      textTransform: "none",
      fontSize: 16,
      fontWeight: 400,
    },
    "& .MuiTabs-indicator": {
      width: "40px!important"
    }
  }
};
AdministratorStatistics = withStyles(styles)(AdministratorStatistics);

export default AdministratorStatistics
